import { formatPrice, type Currency } from "@nh/shared";

/**
 * El importe formateado para una moneda, y los centavos de los que sale.
 *
 * ── Una sola función de dinero ───────────────────────────────────────
 * `formatPrice` es la del contrato compartido, la misma que usan el
 * catálogo y el carrito. Enseña los centavos ("$6,000.00") y el sistema
 * actual no —hace `toLocaleString()` sobre unidades enteras—, pero tener
 * una segunda forma de escribir dinero en el proyecto es exactamente lo
 * que produce dos cifras distintas para el mismo importe. El precio vive
 * en centavos hasta el último momento; la división por 100 ocurre dentro
 * de `formatPrice` y en ningún otro sitio.
 *
 * ── El locale lo manda la MONEDA, no el idioma ───────────────────────
 * Es lo que hace el original, y no es un descuido. Un importe en dólares
 * formateado con `es-MX` sale como "USD 350.00": `Intl` mete el código de
 * la moneda porque el símbolo "$" es ambiguo en México. Y como la
 * pantalla ya escribe el código al lado —"USD · al año · por usuario"—,
 * el resultado sería "USD 350.00 USD". Con el locale de la moneda los dos
 * importes salen con "$" limpio y la etiqueta de al lado es la que
 * desambigua, que es justo para lo que está.
 *
 * Devuelve también los centavos: quien algún día abra el cobro necesita
 * el número, no la cadena.
 *
 * Los precios llegan de `useFranchiseSettings` (lo que el admin guardó),
 * no de una constante: desde el 14-sep-2026 la landing enseña lo mismo
 * que el servidor cobra.
 */
export function franchisePrice(
  currency: Currency,
  prices: Readonly<Record<Currency, number>>,
): { cents: number; text: string } {
  const cents = prices[currency];
  const locale = currency === "USD" ? "en-US" : "es-MX";

  return { cents, text: formatPrice(cents, currency, locale) };
}
